export const ratingPlatforms = {
    capterra: {
        name: 'Capterra',
        reviewUrl: 'https://reviews.capterra.com/products/new/7289a608-6bcd-420f-939f-a6d200b7c72c/'
    },
    g2: {
        name: 'G2',
        reviewUrl: 'https://www.g2.com/products/ezclocker/take_survey'
    }
};
